import { Controller, FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DevTool } from "@hookform/devtools";
import { useEffect, useState } from "react";
import schema from "./Validation";
import { Grid } from "@mui/material";
import { AcademicLevel, Campaigns, ConsentementMultiple,  MentionsLegales, RequiredFields, Submit} from "components";
import { Email, InputText, PhoneNumber } from "components/fields";
import { useForms, useSalesforce, useUrlReturn } from "hooks";
import {
  campaigns,
  consent, consentement, defaultValues, getCampus, salutations, specialities
} from "services";
import DropdownCommon from "components/fields/DropdownCommon";
import formations from "../services/formations";



const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar, setSnackMessage, setSnackSeverity } = useForms();
  const { url } = useUrlReturn('ISTM-WEBINAR');
  const {url : url_contact} = useUrlReturn('ISTM-CONTACT');

  // Form
  const methods = useForm({
    defaultValues: {
      ...campaigns,
      ...consent,
      lead: {
        ...defaultValues,
        ...specialities.lead,
        ...consentement,
        Campus__c: 'Paris',
        Section__c: '',
        Wished_Programm__c: '',

      }
    },
    resolver: yupResolver(schema)
  });
  const { control, watch } = methods;
  const [optionsAcademicLevels, setOptionsAcademicLevels] = useState([]);
    useEffect(() => {
  const timer = setTimeout(() => {
    document.querySelectorAll('.MuiAlert-root').forEach(alert => {
      alert.innerHTML = alert.innerHTML.replace(' à Paris', '');
    });
  }, 100);
  return () => clearTimeout(timer);
}, []);
  const onSubmit = async data => {
    setOpenSnackbar(false);
    const lead = data.lead;
    const campaignId = data.campaignId;

    const defaultDataLead = {
      Division__c: 'IONIS STM',
      IONISSchool__c: 'IONIS STM',
      LeadSource: 'Webinar',
      RecordTypeId: recordTypeId,
      LastForm__c:'Live Event'
    };

    const finalLead = { ...lead, ...defaultDataLead };

    try {
      const leadCreated = await salesforce.createLead(finalLead);


      if (campaignId !== 'unavailable') {
        const campaignMember = {
          CampaignId: campaignId,
          LeadId: leadCreated.Id,
          Status: data.status,
        };
        await salesforce.createCampaignMember(campaignMember);
        document.location.href = url;
      } else {
        document.location.href = url_contact;
      }
    } catch (error) {
      console.error(' Error during form submission:', error);
      setError('Une erreur est survenue lors de la soumission du formulaire', error);
    }
  };

  useSalesforce('Ionis-STM', false);


  const handleAcademicLevels = (academics) => {
    setOptionsAcademicLevels(academics);
  };

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber
            control={control}
            name="lead.MobilePhone"
            label="Téléphone"
            required
          />
        </Grid>
        <Grid item xs={12}>
          {/** Dropdown normal for Wished Program */}
          <Controller
            control={control}
            name="lead.Wished_Programm__c"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <DropdownCommon
                label="Par quelle filière êtes-vous intéressé(e) ?"
                name="lead.Wished_Programm__c"
                native
                onChange={onChange}
                value={value || ''}
                error={error}
                required
                renderOptions={[
                  <option key="empty-option" value="" />,
                  ...formations.map(formation => (
                    <option key={formation.value} value={formation.value}>
                      {formation.label}
                    </option>
                  ))
                ]}
              />
            )}
          />
        </Grid>
        <AcademicLevel academics={optionsAcademicLevels.map(level => level.value)} native options={optionsAcademicLevels} school="IONIS STM" section={false} />
        <Campaigns contact={false} division="IONIS STM" last_form="Live Event" native school="IONIS STM" setAcademicLevels={handleAcademicLevels} text="au live" textAvailability="pour nos évènements virtuels" type="Webinar" />

        {/* <Disponibilites text="les Journées Portes Ouvertes" /> */}
        <ConsentementMultiple />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="JPO" school="IONIS STM" />
      </Grid>
    </FormProvider>
  )
};

export default Form;
